/**
 * The catalogue shown in the Collections section.
 *
 * Images are produced by `node scripts/build-media.js` from the original
 * shoot in DATA/. Slugs here match the filenames that script writes.
 */

export const categories = [
  { id: 'all', label: 'All Pieces' },
  { id: 'bridal', label: 'Bridal & Polki' },
  { id: 'antique', label: 'Antique Gold' },
  { id: 'diamond', label: 'Diamond & CZ' },
  { id: 'rings', label: 'Rings' },
  { id: 'bangles', label: 'Bangles & Bracelets' },
  { id: 'pendants', label: 'Chains & Pendants' },
  { id: 'watches', label: 'Watches' },
];

const piece = (slug, cat, name, note) => ({
  slug,
  cat,
  name,
  note,
  src: `/media/products/${slug}.webp`,
  thumb: `/media/products/${slug}-sm.webp`,
});

export const pieces = [
  piece('bridal-01', 'bridal', 'Emerald Bead Layered Haar', 'Polki pendant on strung emerald beads'),
  piece('bridal-02', 'bridal', 'Kundan Choker', 'Emerald bead rows with a kundan centrepiece'),
  piece('bridal-03', 'bridal', 'Polki & Emerald Set', 'Necklace with matched drop earrings'),
  piece('bridal-04', 'bridal', 'Emerald Drop Necklace', 'Uncut polki frames with emerald centres'),
  piece('bridal-05', 'bridal', 'Bridal Polki Suite', 'Necklace and earrings in antique gold'),

  piece('antique-01', 'antique', 'Long Gold Haram', 'Multi-strand chain with jhumka pair'),
  piece('antique-02', 'antique', 'Ghungroo Choker', 'Antique-finish gold with bead fringe'),
  piece('antique-03', 'antique', 'Temple Haram', 'Full-length antique gold with ruby accents'),
  piece('antique-04', 'antique', 'Jhumka & Necklace Set', 'Pearl strung antique gold'),
  piece('antique-05', 'antique', 'Traditional Gold Set', 'Necklace with matched jhumkas'),

  piece('diamond-01', 'diamond', 'Diamond Drop Necklace', 'Graduated brilliants with pendant drop'),
  piece('diamond-02', 'diamond', 'Rose Gold Necklace', 'Pavé set line with emerald detail'),
  piece('diamond-03', 'diamond', 'Ruby & Diamond Set', 'Statement necklace with matched earrings'),
  piece('diamond-04', 'diamond', 'Sapphire Suite', 'Necklace, ring and earrings'),
  piece('diamond-05', 'diamond', 'Everyday Diamond Pendants', 'Slim chains for daily wear'),

  piece('ring-01', 'rings', 'Floral Cocktail Ring', 'Dome of brilliants in rose gold'),
  piece('ring-02', 'rings', 'Solitaire Band', 'Clean setting, rose gold shank'),
  piece('ring-03', 'rings', 'Ruby Statement Ring', 'Channel-set stones with ruby crown'),
  piece('ring-04', 'rings', 'Polki Halo Ring', 'Uncut centre in a diamond halo'),
  piece('ring-05', 'rings', 'Aquamarine Ring', 'Emerald-cut centre stone'),

  piece('bangle-01', 'bangles', 'Diamond Bangle Pair', 'Matched pair, full pavé'),
  piece('bangle-02', 'bangles', 'Studded Kada', 'Rose gold with diamond channels'),
  piece('bangle-03', 'bangles', 'Openable Bracelets', 'Polki and gold, set of three'),
  piece('bangle-04', 'bangles', 'Baguette Tennis Bracelet', 'Rose gold, secured clasp'),
  piece('bangle-05', 'bangles', 'Wave Bracelet', 'Tapered brilliant-set curve'),

  piece('pendant-01', 'pendants', 'Sapphire Pendant Set', 'Pendant with matched studs'),
  piece('pendant-02', 'pendants', 'Cuban Link Chain', 'Rose gold, pavé finish'),
  piece('pendant-03', 'pendants', 'Kundan Pendant Set', 'Blue enamel with pearl drops'),
  piece('pendant-04', 'pendants', 'Clover Pendant', 'Mother-of-pearl with earrings'),
  piece('pendant-05', 'pendants', 'Emerald Pendant Set', 'Pear-cut emerald with diamond frame'),

  piece('watch-01', 'watches', 'Rose Gold Dress Watch', 'Slim case, bracelet strap'),
  piece('watch-02', 'watches', 'Diamond Bezel Watch', 'Two-tone bracelet'),
  piece('watch-03', 'watches', 'Sport Bracelet Watch', 'Rose gold with textured dial'),
  piece('watch-04', 'watches', 'Baguette Bracelet Watch', 'Stone-set case and band'),
];

/**
 * Worn-on-model shots used for the campaign strip.
 * `label` is the short caption printed over the image; `alt` stays long and
 * descriptive for screen readers.
 */
export const editorial = [
  { slug: 'editorial-01', label: 'Bridal', src: '/media/editorial/editorial-01.webp', alt: 'Bridal necklace and maang tikka worn with a traditional saree' },
  { slug: 'editorial-02', label: 'Emerald Choker', src: '/media/editorial/editorial-02.webp', alt: 'Emerald choker worn on a studio portrait' },
  { slug: 'editorial-03', label: 'Drop Earrings', src: '/media/editorial/editorial-03.webp', alt: 'Black and white portrait showing drop earrings' },
  { slug: 'editorial-04', label: 'Rose Gold Studs', src: '/media/editorial/editorial-04.webp', alt: 'Close-up of a rose gold ear stud' },
  { slug: 'editorial-05', label: 'Diamond Bangles', src: '/media/editorial/editorial-05.webp', alt: 'Diamond bangles worn with a red saree' },
  { slug: 'editorial-06', label: 'Diamond Kada', src: '/media/editorial/editorial-06.webp', alt: 'Wide diamond kada worn on the wrist' },
];

export default pieces;
